import MeetExperience from "./MeetExperience/MeetExperience";

/** Bourbon City Spectacular landing page */
const Meet = () => <MeetExperience preferredSlug="bourbon-city-spectacular-2025" />;

export default Meet;
